import { render, staticRenderFns } from "./PatientDemographicsFormComponent.vue?vue&type=template&id=0a92bb9c"
import script from "./PatientDemographicsFormComponent.vue?vue&type=script&lang=ts"
export * from "./PatientDemographicsFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports